export default "__VITE_ASSET__BHQrj$uG__"